module.exports = __webpack_public_path__ + "img/logo1.fd35e85e.png";